
<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>

<div
	[class]="'layout-menu-dim layout-topbar-light'"
	[ngClass]="{
      'p-ripple-disabled': false,
      'layout-static': isStatic() && !isDocumentViewerRoute,
      'layout-static-active':
         this.isMenuActive && isStatic() && !isDocumentViewerRoute,
      'layout-mobile-active': this.isMobileActive() && !isDocumentViewerRoute,
      'layout-document-viewer': isDocumentViewerRoute
   }"
	class="layout-wrapper"
>
	<app-topbar
		*ngIf="!isDocumentViewerRoute"
		(menuToggle)="this.onMenuToggle()"
	></app-topbar>

	<div class="layout-main">
		<div class="layout-content">
			<p-toast position="top-right"></p-toast>
			<p-confirmDialog></p-confirmDialog>

			<div
				class="p-fluid p-grid"
				[class.document-viewer-route-grid]="isDocumentViewerRoute"
			>
				<div
					class="sm-12 md-12 lg-12 pt-4"
					[class.document-viewer-route-host]="isDocumentViewerRoute"
				>
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>

	<div
		*ngIf="!isDocumentViewerRoute && staticMenuMobileActive"
		class="layout-mask modal-in"
	></div>

	<app-org-wizard-dialog
		*ngIf="!isDocumentViewerRoute"
		[isVisible]="isOrgWizardVisible"
		(orgWizardDialogCloseClose)="this.onOrgWizardClose()"
	></app-org-wizard-dialog>
</div>
